export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ұсыныс берушінің шотын таңдау"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ұсыныс берушінің шоты"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}